<template>
  <table class="striped admin-billing-codes-table">
    <caption v-html="caption" v-if="caption" />
    <colgroup>
      <col width="15%" />
      <col width="50%" />
      <col width="15%" />
      <col width="20%" />
    </colgroup>
    <thead>
      <tr>
        <th>Billing Code</th>
        <th>Description</th>
        <th>Rate</th>
        <th>Sage General Ledger Account</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="billingCode in paginatedBillingCodes"
        :key="billingCode.id"
        :class="selectedId === billingCode.id ? 'selected' : 'selectable'"
        @click="handleSelect(billingCode)"
      >
        <td>{{ billingCode.code }}</td>
        <td>{{ billingCode.description }}</td>
        <td>{{ formatCurrency(billingCode.fee) }}</td>
        <td>{{ billingCode.accountNumber }}</td>
      </tr>
      <tr v-if="billingCodes.length === 0">
        <td class="no-records" colspan="4">
          There are currently no billing codes in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="4">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("billingCodes")],

  props: {
    billingCodes: {
      type: Array,
    },
    caption: {
      type: String,
      default: undefined,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(billingCode) {
      this.$emit("select", billingCode);
    },
  },
};
</script>